module.exports = __webpack_public_path__ + "static/media/fullScreen.a7ce0b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/ctc/fullScreen.jpg
// module id = 471
// module chunks = 0